import { InnerBox } from "@/components/elements/InnerBox";
import { Stack } from "@mui/material";
import { FC } from "react";
import { DashboardProvider } from "@/features/dashboard/providers/DashboardProvider";
import { TopAlert } from "@/features/dashboard/components/TopAlert";
import { DashboardInitialSetup } from "@/features/dashboard/components/DashboardInitialSetup";
import { Notification } from "@/components/commons/notification/Notification";
import { useTutorialVisibility } from "@/features/dashboard/hooks/useTutorialVisibility";

type TDashboardPageProps = {};

export const DashboardPage: FC<TDashboardPageProps> = () => {
  const { shouldShowTutorial, handleHideTutorial } = useTutorialVisibility();

  return (
    <DashboardProvider>
      <Stack gap={4}>
        <TopAlert />
        {shouldShowTutorial && <DashboardInitialSetup onHide={handleHideTutorial} />}
        <InnerBox title="お知らせ" variantTitle="head20Bold" showDivider={false} gap={3}>
          <Notification isHideContent={true} isSingleLine={true} isPreview />
        </InnerBox>
      </Stack>
    </DashboardProvider>
  );
};
